import { NotificationProvider } from '@components';
import { Dashboard } from '@app/pages';
import { useAppCookies } from '@app/providers/AppCookieProvider';

// Broke out this component so I can use cookies.
// this also allows me to pull the router up to main.tsx
// and then use useNavigate for the main menu instead
// of window.location.href
export const DashboardWithCookies = () => {
  const cookies = useAppCookies();
  return <NotificationProvider>{cookies.profile.available ? <Dashboard /> : null}</NotificationProvider>;
};
